import { ApiRequestFilters } from '../../../shared/types/api-request-filters';

/**
 * Vehicle insurance claims filters
 */
export class VehicleInsuranceClaimsFilters extends ApiRequestFilters {}
